
<template>
    <div>
        <slot/>
    </div>
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import { MiniProgram } from '@baidu/bend-sdk';
import { Vue } from "./index";
import { sendWebb } from './common/js/log.js';
import { GATEWAY_SIDS_KEY, GATEWAY_SIDS_RESULT } from './common/js/experiment';
import { sendJsErrorLog } from './common/js/spy';
// import {getIsBaiduBoxFlag} from './static/utils/h5SchemeSwanApp.js';
import log from './static/utils/ubcLog';
import { reqQbData } from './static/utils/get-qb-data';
import { getUserInfo } from './static/utils/index';
import * as location from './static/utils/location';
import { weirwoodErrorReport } from './common/js/weirwood/init';
import weirwoodOption from './common/js/weirwood/initH5';
import * as Weirwood from '@baidu/weirwood-sdk';

// h5端错误上报
{
  const weirwood = Weirwood.init(weirwoodOption);
  Vue.config.errorHandler = err => {
    weirwood.error.captureException(err);
  };
}

// 小程序引入反爬miao-wu动态库
let AntiBot = null;
export default {
  // 全局数据
  globalData: {
    system: {},
    // 来源字段
    ref: '',
    // 进入小程序的path
    path: '',
    // 日志全局字段
    log: {
      lid: '',
      applid: '',
      referlid: '',
      pd: 'law'
    },
    m: {
      navigateStart: 0,
      invokeStart: 0
    },
    bendSDKLog: {},
    location: {
      // 纬度
      lat: null,
      // 经度
      long: null,
      // 城市和经纬度不一定匹配，城市用户可选择，经纬度始终是当前位置经纬度
      cityCode: null,
      cityName: null,
      curCity: null,
      // 经纬度所在城市
      province: null // 省份，经销商中台接口需要省份
    },

    // 找律师页面 地址筛选条件
    expertListCityData: {
      cityName: null,
      cityCode: null,
      curCity: null
    },
    // 找律师咨询领域tab
    consultingField: {
      name: ''
    },
    // 平台ios, android
    platform: '',
    sysInfo: null,
    userInfo: {
      bduss: '',
      'baidu_id': '',
      sid: '',
      is_login: -1,
      user_name: '',
      user_avatar: 'http://himg.baidu.com/sys/portrait/item/db177779776c766c696e3130g0a7801000000'
    },
    // 法典页需用的 query词
    codeGroundQuery: '',
    fromScene: '',
    getQbInfo: null,
    ts: '',
    // 刷新律师列表的时间戳参数
    expertiseArea: '',
    // 刷新律师列表的领域参数
    currentDomains: '',
    // 精选问答记录本次选择领域数据
    // 实验字段
    zhishiSids: '',
    // 实验结果-字段
    lawExpTags: {}
  },
  onError(err) {
    /* eslint-disable no-console */
    if (err && err.message && err.message !== '') {
      // err.message 中包含报错信息和 堆栈，需要格式化分开，便于展示。
      let errArray = err.message.split('\n');
      if (errArray.length > 1 && (!err.stack || err.stack === '')) {
        err.stack = errArray.splice(1);
      }
      let paths = getCurrentPages().map(item => item.uri);
      sendWebb({
        type: 'except',
        group: 'common',
        info: {
          msg: errArray[0],
          stack: err.stack,
          paths: paths.join(',')
        }
      });
      const {
        platform
      } = getApp().globalData && getApp().globalData.sysInfo || {};
      // 错误上报,开发者工具不上报
    }
  },
  mounted() {
    (function () {
      {
        /* eslint-disable */
        // http://wiki.baidu.com/pages/viewpage.action?pageId=1091189830
        const ubc = require('@baidu/ubc-report-sdk');
        // getApp().globalData.UbcLoggerH5 = ubc.default;
        getApp().globalData.UbcLoggerH5 = ubc.default;
        // ubc('init', 'your serverId', {
        //     timingId: 'your timing_id',
        //     page: 'home'
        // });
      }

      log.send && log.send({
        serverId: 16069,
        area: 'app-show',
        action: 'load'
      });
      this.$root.$emit("marsAppAfterMounted", this);
    }).call(this, this.$route.query);
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsAppAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  created() {
    (function (info) {
      let app = getApp(); // h5不能直接通过this获取
      app.globalData.fromScene = info.scene || 0;
      let sys = app.globalData.system;
      let originFr = '';
      // 本地实验读取
      app.globalData.zhishiSids = app.$api.getStorageSync(GATEWAY_SIDS_KEY) || '';
      let lawExpTags = app.$api.getStorageSync(GATEWAY_SIDS_RESULT);
      app.globalData.lawExpTags = lawExpTags && JSON.parse(lawExpTags) || {};
      if (info.query && info.query.fr !== 'baidu_map_legal_tips_h5') {
        originFr = document.referrer;
        // 冷启获取定位，写回全局
        location.get().catch(e => {
          console.log(e); // eslint-disable-line
        });
      }

      log.addGlobalKey({
        originFr
      });
      // 初始化日志统计模块
      let bendSDK = new MiniProgram({
        // 日志相关
        log: {
          appid: '16570201',
          pid: '72',
          sub_pid: '3'
        }
      });
      // 系统信息
      let sysInfo = this.$api.getSystemInfoSync();
      getApp().globalData.sysInfo = sysInfo;
      // 获取场景值
      getApp().globalData.scene = info.scene;
      // 判断是否是从桌面快捷
      getApp().globalData.table = info.scene && Number(info.scene) === 12300000 || false;
      // 获取用户信息
      getUserInfo().then(({
        user_avatar,
        ...rest
      } = {}) => {
        getApp().globalData.userInfo = {
          ...getApp().globalData.userInfo,
          ...(user_avatar && {
            user_avatar
          }),
          ...rest
        };
      }).catch(() => {});
      // sa是约定的额外的取到来源
      if (info.query) {
        if (info.query.sa) {
          getApp().globalData.sa = info.query.sa;
        }
        if (info.query.sid) {
          getApp().globalData.sid = info.query.sid;
        }
        if (info.query.query) {
          getApp().globalData.word = info.query.query;
        }
        if (info.query.ref) {
          getApp().globalData.ref = info.query.ref;
        }
      } else {
        if (info.sa) {
          getApp().globalData.sa = info.sa;
        }
        if (info.sid) {
          getApp().globalData.sid = info.sid;
        }
        if (info.query) {
          getApp().globalData.word = info.query;
        }
        if (info.ref) {
          getApp().globalData.ref = info.ref;
        }
      }
      {
        sys.statusBarHeight = 0;
        sys.navigationBarHeight = 44;
        window.bendSDKLog = bendSDK;
        app.globalData.platform = 'web';
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
        const UA = window.navigator.userAgent.toLocaleLowerCase();
        getApp().globalData.isUC = UA.match(/vivo/i) === 'vivo' || UA.match(/ucbrowser/i) === 'ucbrowser' || UA.match(/quark/i) === 'quark';
        sendJsErrorLog(Vue);
      }
      // miao-wuzu库需要的sid、keyId（写死）

      info.query = {
        ...info
      };
      if (info.query.qid) {
        getApp().globalData.getQbInfo = {
          qid: info.query.qid,
          req: reqQbData({
            query: info.query,
            data: {
              mode: 'launch_req'
            }
          })
        };
      }
      this.$root.$emit("marsAppAfterCreated", this);
    }).call(this, this.$route.query);
  }
};
const pageHideLog = () => {
  // 防止重复统计
  if (!pageStartTime) {
    return;
  }
  // 访问时长统计
  let lengthOfStay = Date.now() - pageStartTime;
  pageStartTime = 0;
  log.send({
    area: 'duration',
    action: 'show',
    dur: lengthOfStay,
    serverId: 17291,
    page: prePageName
  });
};
// Page.after 可拦截页面上的生命周期和页面方法和事件(包括自定义组件、页面)；未指定匹配 url 时，拦截所有页面；
// 触发时机：对应处理访问执行之后执行。
let pageStartTime = null;
let prePageName = '';
Page.after({
  // url: /pages\/[a-z]+/,
  methods: {
    onShow() {
      // 记录用户进入时间
      pageStartTime = Date.now();
      const pages = getCurrentPages();
      const nowPage = pages[pages.length - 1] || {};
      const pageArr = nowPage.uri ? nowPage.uri.split('/') : [];
      prePageName = pageArr[2] && pageArr[2] !== 'index' ? pageArr[2] : pageArr[1] || '';
    },
    onHide() {
      pageHideLog();
    },
    onTabItemTap(item) {
      try {
        let tab = item.args.e;
        log.send({
          serverId: 16138,
          area: ['bottom_index_click', 'bottom_bdls_click', 'bottom_lawyer_click', 'bottom_my_click'][tab.index],
          action: 'click'
        });
      } catch (e) {}
    }
  }
});
</script>

<style scoped>
@import "./static/css/ljr.css";
@import "./static/iconfont/iconfont.css";
/* iconfont 覆盖iconfont.css 里定义 */
.iconfont,
[class*="__iconfont"]  {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}



@import "~@baidu/mars-ui/dist/h5/mars-ui.css";


</style>
